module.exports = __webpack_public_path__ + "img/full6-min.ca1d9feb.png";